import { isEmpty } from '@pes-ui/utils';
import { switchProductSelector } from './product-selector-utils';
export class ProductSelector {
  constructor() {
    this.config = undefined;
    this.renderFunction = undefined;
    this.selector = undefined;
  }
  openPesProductSelector(config) {
    if (this.selector) {
      this.openingProductSelector.emit(config);
      this.selector.open(config);
    }
    else {
      console.error("Selector wasn't inited");
    }
  }
  componentWillLoad() {
    if (!this.config)
      return;
    const productSelector = switchProductSelector(this.config);
    if (productSelector) {
      productSelector.then((selector) => {
        this.selector = selector;
      });
    }
  }
  render() {
    if (isEmpty(this.config) || !this.selector) {
      return null;
    }
    return this.renderFunction(this.selector);
  }
  static get is() { return "pes-product-selector"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-selector.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-selector.css"]
    };
  }
  static get properties() {
    return {
      "config": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductSelectorConfig",
          "resolved": "Omit<TScProductSelectorConfig, \"type\"> & Omit<THpcProductSelectorConfig, \"type\"> & { type: \"hpc\" | \"cr\" | \"sc\"; } | { type: \"disabled\"; } | { type: \"ez\"; ezProductSelectorUrl: string; } | { type: \"sc\"; scConfiguratorUrlJS: string; scConfiguratorUrlCSS: string; scLanguage: string; scCountry: string; scToken: string; scProject: string; scDataset: string; scOptions: Record<string, unknown>; scFunctionalIds: string; scLabel: string; }",
          "references": {
            "TProductSelectorConfig": {
              "location": "import",
              "path": "./commonTypes"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Selector config"
        }
      },
      "renderFunction": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(selector: ISelector<TProductSelectorConfig>) => HTMLElement",
          "resolved": "(selector: ISelector<TProductSelectorConfig>) => HTMLElement",
          "references": {
            "ISelector": {
              "location": "import",
              "path": "./types"
            },
            "TProductSelectorConfig": {
              "location": "import",
              "path": "./commonTypes"
            },
            "HTMLElement": {
              "location": "global"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "selector": {}
    };
  }
  static get events() {
    return [{
        "method": "openingProductSelector",
        "name": "openingProductSelector",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TProductSelectorConfig",
          "resolved": "Omit<TScProductSelectorConfig, \"type\"> & Omit<THpcProductSelectorConfig, \"type\"> & { type: \"hpc\" | \"cr\" | \"sc\"; } | { type: \"disabled\"; } | { type: \"ez\"; ezProductSelectorUrl: string; } | { type: \"sc\"; scConfiguratorUrlJS: string; scConfiguratorUrlCSS: string; scLanguage: string; scCountry: string; scToken: string; scProject: string; scDataset: string; scOptions: Record<string, unknown>; scFunctionalIds: string; scLabel: string; }",
          "references": {
            "TProductSelectorConfig": {
              "location": "import",
              "path": "./commonTypes"
            }
          }
        }
      }];
  }
}
